import './about.css'
import AboutFounder from "./about1"
export default function About() {
  return (
    <><div className="aboutPage">
      <section className="heading">
       <div className='text'>
         {/* <small>A few Words...</small> */}
        <h1>About Us</h1>
       </div>
       
      </section>
     
      <AboutFounder/>
    </div>
      
    </>
  );
}
